import nookies, { destroyCookie } from 'nookies'
import { User } from 'services/types/user'

export const TOKEN_STORAGE_NAME = 'perpusuki.web.token'
export const USER_STORAGE_NAME = 'perpusuki.web.user'

export function getTokenCookie(): string {
  return nookies.get()[TOKEN_STORAGE_NAME]
}
export function getUserCookie(): User {
  if (!nookies.get()[USER_STORAGE_NAME]) return null
  return JSON.parse(nookies.get()[USER_STORAGE_NAME])
}

export function setTokenCookie(token: string) {
  nookies.set(null, TOKEN_STORAGE_NAME, token, {
    maxAge: 24 * 60 * 60,
    path: '/',
  })
}

export function setUserCookie(user: User) {
  nookies.set(null, USER_STORAGE_NAME, JSON.stringify(user), {
    maxAge: 24 * 60 * 60,
    path: '/',
  })
}

export function removeTokenCookie() {
  destroyCookie(null, TOKEN_STORAGE_NAME)
}

export function removeUserCookie() {
  destroyCookie(null, USER_STORAGE_NAME)
}
